import { useMemo } from 'react';

export const useShowBusinessIdHook = (countryCode: string | undefined) => {
    const showBusinessIdField = useMemo(() => {
        return ['AU', 'ZA', 'SG'].includes(countryCode || '');
    }, [countryCode]);

    return showBusinessIdField;
};
